// extracted by mini-css-extract-plugin
module.exports = {"container":"UserMenu_container__2cy92","title":"UserMenu_title__2jixm","button":"UserMenu_button__34v86"};